import { css } from 'styled-components'

export const copyText = css`
  font-size: 2.3125rem;
  line-height: 1.6756756756756757;
  letter-spacing: 0.1em;
  @media (max-width: 60rem){
    font-size: 2rem;
    line-height: 1.5;
  }
`

export const mainText1 = css`
  font-size: 1.125rem;
  line-height: 2.799999952316284;
  letter-spacing: 0.05em;
  @media (max-width: 60rem){
    font-size: 1rem;
    line-height: 2.25;
  }
`

export const headEnText = css`
  font-size: 1.40625rem;
  line-height: 1.25;
  letter-spacing: 0.05em;
  font-family: var(--sans-serif-font);
  @media (max-width: 60rem){
    
  }
`

export const headJaText = css`
  font-size: 0.84375rem;
  letter-spacing: 0.03em;
  font-family: var(--sans-serif-font);
  @media (max-width: 60rem){
    
  }
`

export const boxCopyText = css`
  font-size: 1.6875rem;
  line-height: 1.8518518518518519;
  letter-spacing: 0.12em;
  @media (max-width: 60rem){
    font-size: 1.375rem;
    line-height: 1.5;
    letter-spacing: 0.05em;
  }
`

export const boxMainText = css`
  font-size: 1rem;
  line-height: 1.95;
  letter-spacing: 0.05em;
  font-weight: 300;
  @media (max-width: 60rem){
    
  }
`